






import { defineComponent } from "@vue/composition-api";
import providers from "@/lib/api";
import { $t } from "@/lib/i18nHelpers";
import BasePage from "@/components/BasePage";
import IdentityVerificationConfirm from "@/components/IdentityVerificationConfirm";

export default defineComponent({
  name: "PageIdentityVerification",
  components: { BasePage, IdentityVerificationConfirm },
  setup() {
    const handleStartVerification = async () => {
      const open = (w: number, h: number) => {
        const left = screen.width / 2 - w / 2,
          top = screen.height / 2 - h / 2;
        const config = `width=${w}, height=${h}, top=${top}, left=${left}, toolbar=0, location=1, directories=0, status=0, menubar=0, scrollbars=1, resizable=0, copyhistory=0,`;
        return window.open("about:blank", "_blank", config);
      };
      const tab = open(700, 1200);
      if (!tab) {
        alert($t("Please disable popups blocking in your browser to proceed."));
      } else {
        tab.location.href = await providers.StripeKycProvider.start();
      }
    };

    return {
      handleStartVerification,
    };
  },
});
